import { ApiRequestError } from './fetch-request'

// The API rejects invalid characters with:
// "<field>" with value "<value>" fails to match the required pattern: /^[<allowed characters>]*$/
const INVALID_CHARACTERS =
  /"[^"]+" with value "(.*)" fails to match the required pattern: \/\^(\[.*\])[*+]\$\//

// POST /api/files validates alternatives, so it reports this instead of naming the field.
const NO_MATCHING_TYPE = '"value" does not match any of the allowed types'

export function formatInvalidInput(apiMessage: string): string {
  if (apiMessage === NO_MATCHING_TYPE) {
    return 'Your input includes invalid characters.'
  }

  const match = apiMessage.match(INVALID_CHARACTERS)
  if (!match) return apiMessage

  const value = match[1]
  const allowedCharacters = match[2]
  const allowed = new RegExp(`^${allowedCharacters}$`)

  const uniqueCharacters = Array.from(new Set(value))
  const notAllowed = uniqueCharacters.filter((char) => !allowed.test(char))

  return `"${value}" contains characters that cannot be used: ${notAllowed.join(' ')}.`
}

export function invalidInputMessage(error: unknown): string | undefined {
  if (!(error instanceof ApiRequestError) || error.statusCode !== 400) {
    return undefined
  }

  return error.apiMessage ? formatInvalidInput(error.apiMessage) : undefined
}
